(function () {
    'use strict';

    angular
        .module('campaignStatusMgmtModule', [
            'services.historyCtxt'
        ]);
})();
